/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Italian (it) string table
   English is the source of truth in the HTML; this file supplies the
   Italian counterpart for each data-i18n key. Missing keys fall back to
   English automatically (see i18n.js). Hand this file to a translator or
   compliance reviewer; it is the single place Italian copy lives.

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English. Informal "tu", never "Lei"
   or "voi" for singular address. Standalone "serum" → "siero".
═════════════════════════════════════════════════════════════════════ */
window.TD_I18N = window.TD_I18N || {};
window.TD_I18N.it = Object.assign(window.TD_I18N.it || {}, {

  /* ── Nav (site-wide) ── */
  'nav.shop': 'Shop',
  'nav.science': 'Scienza',
  'nav.concerns': 'Esigenze della pelle',
  'nav.story': 'La nostra storia',
  'nav.contact': 'Contatti',
  'nav.tryus': 'Provaci',
  'nav.faq': 'Domande frequenti',
  'nav.drawerCta': 'Provaci · Discovery Kit',
  'nav.drawerFine': 'Cinque sieri vitaminici · $70 · spedizione in tutto il mondo',

  /* ── Announcement bar (site-wide) ── */
  'announce.0a': '<strong>Spedizione gratuita</strong> su tutti gli ordini superiori a $150',
  'announce.0b': 'Spedito in tutto il mondo da Stockholm',
  'announce.1a': '<strong>Crea una routine e risparmia il 10%</strong>',
  'announce.1b': 'Applicato automaticamente al checkout',
  'announce.2a': 'Prova tutti e cinque i sieri.',
  'announce.2b': '<strong>Spedizione gratuita oltre $150</strong>',

  /* ── Homepage · hero ── */
  'home.hero.tagline': 'Cura della pelle senza compromessi · Est. 1998',
  'home.hero.h1': '<span class="l1">Senza acqua.</span><br><span class="l2">Senza conservanti.</span><br><span class="l3">Senza additivi.</span><br><span class="l4">Senza coloranti.</span><br><span class="l5">Senza aria.</span><br><span class="l6"><em class="hero-vitamins-em">Solo vitamine attive.</em></span>',
  'home.hero.sub': 'Per un vero assorbimento dermico oltre la superficie.<br>Cinque sieri vitaminici. Cinque principi. Un sistema.',
  'home.hero.cta1': 'Esplora i sieri',
  'home.hero.cta2': 'Come funziona',

  /* ── Homepage · coming-soon teaser (static only) ── */
  'home.cs.title': 'Campagna<br><em>Estate</em> 2026',
  'home.cs.shop': 'Sieri disponibili ora',

  /* ── Homepage · press bar ── */
  'home.press.label': 'Visto su',

  /* ── Homepage · collection ── */
  'home.coll.eyebrow': 'La collezione',
  'home.coll.h2': 'Sieri vitaminici formulati con precisione. <em>Sviluppati a Stockholm.</em>',
  'home.coll.viewAll': 'Vedi tutti i prodotti',
  'home.coll.c.benefit': 'Protegge, illumina e rassoda con pura vitamina C.',
  'home.coll.a.benefit': 'Rinnovamento al retinolo mentre dormi.',
  'home.coll.o.benefit': 'Stimola le cellule e ripristina la luminosità visibile.',
  'home.coll.m.benefit': 'Ripara la barriera idratante. In profondità e a lungo.',
  'home.coll.r.benefit': 'Rassoda e ripristina. Riduce nel tempo l’aspetto delle imperfezioni, dei segni post-acne e delle irregolarità della texture.',
  'home.coll.kit.name': 'Discovery Kit',
  'home.coll.kit.benefit': 'Tutti e cinque i sieri in formato tascabile. Prova l’intero sistema prima di decidere.',
  'home.coll.kit.badge': 'Novità',

  /* ── Homepage · science intro (shared) ── */
  'home.science.eyebrow': 'La scienza',
  'home.science.h2': 'Il rilascio profondo è<br><em>la differenza.</em>',
  'home.science.body': 'Il sistema di rilascio di Transderma trasporta le vitamine attive oltre l’epidermide fino al derma, dove avvengono la sintesi del collagene e il rinnovamento cellulare.',
  'home.science.readMore': 'Leggi tutta la scienza →',

  /* ── Homepage · science skin diagram (static only) ── */
  'home.sci.serumLabel': 'Sieri<br>Transderma',
  'home.sci.l1.label': 'STRATUM CORNEUM',
  'home.sci.l1.desc': 'Strato più esterno della pelle',
  'home.sci.l1.p': 'Lo stratum corneum è la barriera esterna della pelle: cellule morte e compattate che bloccano la maggior parte di ciò che applichiamo. La formula senza acqua di Transderma viene assorbita attraverso di esso in pochi secondi dall’applicazione. Le vitamine attive raggiungono intatte il tessuto vivo sottostante, senza perdite per evaporazione.',
  'home.sci.l1.depth': '0 mm DI PROFONDITÀ',
  'home.sci.l2.label': 'EPIDERMIDE',
  'home.sci.l2.desc': 'Cellule vive della pelle, melanociti, terminazioni nervose',
  'home.sci.l2.p': 'La maggior parte dei sieri si ferma qui, depositata tra le cellule vive dell’epidermide, incapace di andare oltre. Transderma non contiene acqua, quindi ogni goccia mantiene la sua piena concentrazione vitaminica durante il percorso. Nulla viene diluito lungo il cammino; la formula continua ad avanzare verso il derma.',
  'home.sci.l2.depth': '0,1 mm DI PROFONDITÀ',
  'home.sci.l2.stop': 'La maggior parte dei sieri si ferma qui',
  'home.sci.barrier': 'BARRIERA CUTANEA',
  'home.sci.l3.label': 'STRATO DERMICO',
  'home.sci.l3.desc': 'Collagene, elastina, fibroblasti, vasi sanguigni',
  'home.sci.l3.p': 'Il derma è dove si produce davvero un cambiamento duraturo della pelle: collagene, elastina e rinnovamento cellulare iniziano qui. Transderma porta vitamine concentrate direttamente in questo strato, dove i fibroblasti possono metterle al lavoro. Questo è lo strato che i sieri convenzionali raggiungono di rado, ed è il motivo per cui i nostri risultati si vedono nel corso delle settimane.',
  'home.sci.l3.depth': '1–2 mm DI PROFONDITÀ',
  'home.sci.l4.label': 'TESSUTO SOTTOCUTANEO',
  'home.sci.l4.desc': 'Tessuto adiposo e supporto strutturale profondo',
  'home.sci.l4.p': 'Sotto il derma si trova lo strato sottocutaneo, tessuto adiposo che ancora la pelle e ne mantiene la forma. A questa profondità, le vitamine di Transderma sono già state assorbite dal derma soprastante. Il tessuto qui è la base strutturale per il rinnovamento che avviene in ogni strato costruito al di sopra.',
  'home.sci.l4.depth': '4–10 mm DI PROFONDITÀ',
  'home.sci.reach': 'TRANSDERMA ARRIVA FINO A QUI',

  /* ── Homepage · purity / five nos (static + theme strip) ── */
  'home.purity.eyebrow': 'La differenza',
  'home.purity.h2': 'Non è ciò che<br><em>ti aspetti.</em>',
  'home.purity.water.title': 'Senza acqua',
  'home.purity.water.body': 'Formula senza acqua. Concentrazione più alta, rilascio più profondo.',
  'home.purity.preserv.title': 'Senza conservanti',
  'home.purity.preserv.body': 'Senza acqua, i microbi non possono crescere. Non servono.',
  'home.purity.fillers.title': 'Senza additivi',
  'home.purity.fillers.body': 'Ogni ingrediente è funzionale. Nessun emulsionante, addensante o riempitivo di volume.',
  'home.purity.dyes.title': 'Senza coloranti',
  'home.purity.dyes.body': 'La tonalità che vedi proviene dagli attivi grezzi, non da un colore aggiunto.',
  'home.purity.air.title': 'Senza aria',
  'home.purity.air.body': 'Sigillato in una pompa airless. Piena potenza, dalla prima all’ultima goccia.',

  /* ── Homepage · pure formulation strip header (liquid only) ── */
  'home.strip.eyebrow': 'Formulazione pura',
  'home.strip.h3': 'Solo vitamine attive.<br><em>Nient’altro.</em>',

  /* ── Homepage · trust commitments (liquid only) ── */
  'home.trust.cruelty': '<strong>Mai testato sugli animali.</strong> Cruelty-free dal primo giorno.',
  'home.trust.vegan': '<strong>Formulazioni vegane.</strong> Nessun ingrediente di origine animale.',
  'home.trust.made': '<strong>Prodotto a Stockholm.</strong> Approvato in laboratorio da Läkemedelsverket.',
  'home.trust.eu': '<strong>Registrato come cosmetico UE.</strong> Venduto in cliniche di 14 Paesi.',

  /* ── Homepage · airless section (liquid only) ── */
  'home.airless.eyebrow': 'Design airless',
  'home.airless.h2': 'Sigillato dalla prima erogazione<br><em>all’ultima.</em>',
  'home.airless.body': 'L’aria è ciò che fa invecchiare un siero. La pompa airless chiude quella porta. L’ultima goccia ha la stessa potenza della prima.',

  /* ── Homepage · sample / discovery kit ── */
  'home.sample.eyebrow': 'Non sai da dove iniziare?',
  'home.sample.h2': 'Prova tutti e cinque<br><em>per $70.</em>',
  'home.sample.body': 'Il Transderma Discovery Kit contiene versioni in formato tascabile di tutti e cinque i sieri e una guida stampata per costruire la tua routine. È così che la maggior parte dei nostri clienti di lunga data ci ha scoperti per la prima volta.',
  'home.sample.bodyTheme': 'Il Transderma Discovery Kit contiene versioni in formato tascabile di tutti e cinque i sieri. È così che la maggior parte dei nostri clienti di lunga data ci ha scoperti per la prima volta.',
  'home.sample.cta': 'Acquista il Discovery Kit',
  'home.sample.fine': '$5 di spedizione · Include la guida stampata alle esigenze della pelle',
  'home.sample.fineTheme': '$5 di spedizione in tutto il mondo · Spedito da Stockholm',
  'home.sample.f1.h': 'Tutti e cinque i sieri',
  'home.sample.f1.p': 'In formato tascabile, perfetti per chi è in movimento. Circa 7 giorni di uso costante.',
  'home.sample.f1.pTheme': 'Flaconi tascabili da 3 ml, perfetti per chi è in movimento. Circa 7 giorni di uso costante per flacone.',
  'home.sample.f2.h': 'Guida alle esigenze della pelle',
  'home.sample.f2.p': 'Una guida stampata per aiutarti a capire quali sieri rispondono meglio alle tue esigenze specifiche.',
  'home.sample.f2.hTheme': 'Tutti e cinque, fianco a fianco',
  'home.sample.f2.pTheme': 'Inserisci ogni formula nella tua routine nella stessa settimana e trova le combinazioni che funzionano per la tua pelle.',
  'home.sample.f3.h': 'Senza impegno',
  'home.sample.f3.p': 'Scopri se Transderma fa per te. La maggior parte lo capisce nel giro di pochi giorni.',

  /* ── Homepage · skin concerns ── */
  'home.conc.eyebrow': 'Trova la tua formula',
  'home.conc.h2': 'Acquista in base<br><em>alle esigenze della pelle.</em>',
  'home.conc.firm.t': 'Compattezza',
  'home.conc.firm.d': 'Perdita di elasticità e definizione lungo la mandibola e le guance.',
  'home.conc.bright.t': 'Luminosità',
  'home.conc.bright.d': 'Tono non uniforme, opacità e discromie da esposizione ambientale, cicatrici o segni post-acne.',
  'home.conc.hydrate.t': 'Idratazione',
  'home.conc.hydrate.d': 'Pelle secca, desquamazione e una barriera idratante indebolita che non trattiene.',
  'home.conc.lines.t': 'Linee sottili',
  'home.conc.lines.d': 'Linee superficiali e rughe d’espressione più profonde che si sviluppano nel tempo.',
  'home.conc.viewAll': 'Vedi tutte le esigenze della pelle →',

  /* ── Homepage · heritage / founder ── */
  'home.her.caption': 'Dr. Klaus Alvin Ronlán, Ph.D.<br><span>1942 — 2018 · Docente</span>',
  'home.her.eyebrow': 'Il fondatore',
  'home.her.h2': 'Trent’anni.<br><em>La stessa formula.</em>',
  'home.her.body': 'Transderma è nato in un laboratorio di Stockholm, fondato dal Dr. Klaus Alvin Ronlán dopo venticinque anni di ricerca all’Università di Lund. Cinque sieri, lanciati nel 1998. Conservati invariati dalla scomparsa del Dr. Ronlán nel 2018. Ancora di proprietà indipendente. Ancora prodotto in Svezia.',
  'home.her.bodyTheme': 'Transderma è nato in un laboratorio di Stockholm, fondato dal Dr. Klaus Alvin Ronlán dopo venticinque anni di ricerca. Ancora di proprietà indipendente. Ancora prodotto in Svezia.',
  'home.her.cta': 'Leggi la storia del Dr. Ronlán →',

  /* ── Awards · Recognition (site-wide) ── */
  'awards.label': 'Riconosciuto',
  'awards.serumC': 'Nordic Natural Beauty Awards · Vincitore 2020',
  'awards.serumA': 'Global Makeup Awards · Silver, Scandinavia 2022',
  'awards.serumO': 'Swedish Beauty &amp; Cosmetics Awards · Vincitore 2016',
  'awards.serumM': 'Nordic Natural Beauty Awards · Vincitore 2020',
  'awards.serumR': 'ELLE Sweden Beauty Awards · Vincitore 2013',
  'awards.fullLine': 'Riconosciuto da · ELLE Sweden Beauty Awards · Nordic Natural Beauty Awards · Swedish Beauty &amp; Cosmetics Awards · Global Makeup Awards · LUXlife Magazine',
  'awards.aboutLine': 'Riconosciuto · ELLE Sweden 2013 · Swedish Beauty &amp; Cosmetics 2016 · Nordic Natural Beauty 2020 · Global Makeup 2022 · LUXlife 2021',

  /* ── Press pull-quotes (real editorial reviews) ── */
  'quote.home.text': '«Cura della pelle altamente efficace, ai suoi massimi livelli.»',
  'quote.home.cite': 'Melissa Davis · The Beauty Librarian',
  'quote.serumR.text': '«Come per magia sulla pelle. Il mio problema di pigmentazione sul labbro superiore è scomparso.»',
  'quote.serumR.cite': 'Teresa Grundin · Styleby, 2014',
  'quote.serumC.text': '«La scienza dietro questo prodotto e la semplicità della formula sono impressionanti.»',
  'quote.serumC.cite': 'Truth In Aging',
  'quote.serumA.text': '«Cura della pelle al massimo. Transderma A e C.»',
  'quote.serumA.cite': 'Teresa Grundin · Elle.se, 2014',

  /* ── Footer (site-wide) ── */
  'footer.tagline': 'Est. 1998 · Stockholm',
  'footer.location': 'Stockholm, Svezia',
  'footer.col.serums': 'Sieri',
  'footer.col.shop': 'Shop',
  'footer.col.learn': 'Scopri',
  'footer.col.support': 'Assistenza clienti',
  'footer.serums.kit': 'Discovery Kit',
  'footer.serums.gift': 'Carte regalo',
  'footer.shop.all': 'Tutti i sieri',
  'footer.learn.research': 'Ricerca del Dr. Ronlán',
  'footer.learn.science': 'La scienza',
  'footer.learn.concerns': 'Esigenze della pelle',
  'footer.learn.story': 'La nostra storia',
  'footer.learn.about': 'Informazioni sul Dr. Ronlán',
  'footer.support.faq': 'Domande frequenti',
  'footer.support.shipping': 'Spedizioni e resi',
  'footer.support.stockists': 'Punti vendita',
  'footer.support.contact': 'Contatti',
  'footer.support.privacy': 'Privacy',
  'footer.support.terms': 'Termini',
  'footer.copy': '© 2026 Transderma®. Tutti i diritti riservati. Stockholm, Svezia.<svg class="ft-flag" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg" aria-label="Italia"><rect width="20" height="40" fill="#009246"/><rect x="20" width="20" height="40" fill="#FFFFFF"/><rect x="40" width="20" height="40" fill="#CE2B37"/></svg>',
  'footer.links.privacy': 'Privacy',
  'footer.links.terms': 'Termini',

  /* ── Certifications strip (homepage) ── */
  'certifications.label': 'Certificazioni',
  'certifications.ewg': 'EWG Verificato',
  'certifications.certclean': 'CertClean Certificato'

});
